<template>
  <div class="main-login">
    <div class="title">ورود</div>
    <custom-input type="email" placeholder="ایمیل" auth="auth" :emaillogo="true" @getValue="setMail"/>
    <custom-input @showPassword="changeType" :type="type" placeholder="رمز عبور" auth="auth" :passwordlogo="true" @getValue="setPass"/>

    <label>
      <span @click="$router.push('/auth/forgetPassword')" class="forget-pass">فراموشی رمز عبور</span>
    </label>

    <label>
      <button @click="loginUser" class="blue-btn">ورود</button>
    </label>
    یا
    <div class="google" @click="googleSso">
      <img class="google-play" src="../../assets/icon/Google-log.png" alt="">
      <span>ورود از طریق گوگل </span>
    </div>

    <label class="link-div">
      <span>حساب کاربری ندارید؟</span> <a @click="$router.push('/auth/register')" class="link-to-signup"> ثبت نام
      کنید </a>
    </label>

  </div>
</template>

<script>
import CustomInput from "../tools/custom-input";


export default {
  name: "the-login",
  components: {CustomInput},
  data() {
    return {
      type: 'password',
      data: {
        email: "",
        password: "",
        osType: "",
        deviceType: "",
        browser: "",
        referralCode: "",
      },
      emailError: "",
      passError: "",
    }
  },

  methods: {

    async setMail(value){
      this.data.email= value;
      // console.log(this.data.email);
    },
    async setPass(value){
      this.data.password = value;
      // console.log(this.data.password);
    },



    changeType() {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    },
    googleSso() {
      window.location.href = this.$google_sso;
    },
    async checkEmail() {
      if (!this.$validEmail(this.data.email) || !this.data.email) {
        this.emailError = "ایمیل صحیح وارد نمایید";
        this.$error("اطلاعات وارد شده اشتباه است", "ایمیل صحیح وارد نمایید");
        return Promise.reject("repeat failed : " + this.data.email);
      } else {
        this.emailError = "";
      }
    },




    //login with google
    async loginUser() {
      this.checkEmail();
      this.state.loading = true;
      const res = await this.$axios.post("/users/login", this.data);

      if (res.message == "login successful, otp is required") {
        //this function will set username as email into cookies
        this.$cookies.set("username", this.data.email);
        this.state.userInfo.email = this.data.email;
        this.state.userInfo.mobilenumber =
            res.baseDTO.starTwoStepAuthentication || "";
        this.state.towStepAuthenticationType =
            res.baseDTO.towStepAuthenticationType;
        // await this.$router.push(goto[res.baseDTO.towStepAuthenticationType])
        await this.$router.push({name:'OtpEmail'});
      }
      // else if (res.token) {
      //   this.$setToken(res.token, this.state.userInfo.remember)
      //   await this.$router.push('/profile')
      // }
    },

  },
  mounted() {
    this.data.osType = this.$detectOs();
    this.data.browser = this.$detectBrowser() || "CHROME";
    this.data.deviceType = this.$detectDevice();
  },
}
</script>

<style lang="scss" scoped>
.blue-btn {
  font-size: clamp(14px, 1.5vw, 16px);
  font-weight: bold;
}

.main-login {
  display: flex;
  flex-direction: column;
  gap: 30px;
  direction: rtl;
  color: #FBFBFD;

  label {
    position: relative;
    display: flex;
    flex-wrap: wrap;

    img {
      position: absolute;
      left: 16px;
      top: 35%;
    }
  }


  button {
    width: 100%;
  }

  label {
    display: flex;
    align-items: center;
  }


  .google {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: 0.75px solid #8C8585;
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
    color: rgba(140, 133, 133, 1);
    width: 100%;
    height: 36px;
    cursor: pointer;

    .google-play {
      width: 20px;
      height: 20px;
    }
  }

  .link-div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: clamp(14px, 1.5vw, 16px);

  }

  .link-to-signup {
    color: #1199FA;
    cursor: pointer;
    margin-right: 10px;
  }

  .forget-pass {
    color: #1199FA;
    cursor: pointer;
  }

  .title {
    font-size: clamp(16px, 2vw, 22px);
    color: #FBFBFD;
    font-weight: bold;
  }
}
</style>